import {UserRole, toolPrivacy} from './constants';
export const canEditTool = (toolDetails, user, office, permission) => {
  let {createdBy, officeId, privacy,sharedArr} = toolDetails;
  // console.log(toolDetails)
  let {orgAdmin}=user;
  if(createdBy && (createdBy._id === user._id)) {
    return true;
  }
  if(privacy === toolPrivacy.office && (user.officeId && user.officeId._id ) && user.officeId._id === officeId && permission === 'EDIT') {
    return true;
  }

  if( toolDetails.invitedUsers && toolDetails.invitedUsers.length>0){
    let length = toolDetails.invitedUsers.length
      for(var x = 0; x< length; x++){
        let invitedU = toolDetails.invitedUsers[x]
        if(invitedU.value==user._id && invitedU.permissions==1){
          return true;
        }
      }
  }

  // console.log(user, toolDetails.organizationID)
  if(toolDetails.privacy === "ENTERPRISE" && toolDetails.organizationID === user.organizationId._id && permission === "EDIT"){
    return true
  }

  if(privacy === toolPrivacy.officeAndChildren && sharedArr.includes(office.officeHierarchyPath) && permission === 'EDIT') {
    return true;
  }
  if((user.officeId && user.officeId._id ) && user.officeId._id === officeId && user.role === UserRole.admin) {
    return false;
  }
  return false;
}

export const canRemoveShareToolEmails = (toolDetails, user, office) => {
  let {orgAdmin}=user;

  let {createdBy, officeId, privacy, permission,sharedArr} = toolDetails;

  if( createdBy && (createdBy._id === user._id)) {
    return true;
  }
  if( (user.officeId && user.officeId._id) && user.officeId._id === officeId && user.role === UserRole.admin) {
    return true;
  }
  return false;
}

export const canArchiveAndRestoreTool = (toolDetails, user) => {
  let {orgAdmin}=user;

  let toolOwner = toolDetails.createdBy && (toolDetails.createdBy._id === user._id)
  if( toolOwner || user.orgAdmin  ) {
    return true;
  }
  // if( (user.officeId && user.officeId._id ) && user.officeId._id === toolDetails.officeId && user.role === UserRole.admin) {
  //   return true;
  // }

  // if(toolDetails.invitedUsers && toolDetails.invitedUsers.length>0 && toolDetails.invitedUsers.filter(e=> e.value == user._id && e.permissions==1).length>0 ){
  //   return true
  // }
  return false;
}

export const canChangeToolPrivacy = (toolDetails, user) => {
  let {orgAdmin}=user;

  if(!toolDetails.createdBy || toolDetails.createdBy._id === user._id) {
    return true;
  }
  if((user.officeId && user.officeId._id ) &&user.officeId._id === toolDetails.officeId && user.role === UserRole.admin) {
    return true;
  }
  if(orgAdmin){
    return true
  }
  return false;
}

export const canArchiveTool = (toolDetails, user) => {
  let {orgAdmin}=user;
  let toolOwner = toolDetails.createdBy && (toolDetails.createdBy._id === user._id)

  if (toolOwner){
    return true
  }

  // if(toolDetails.lastUpdate.user._id === user._id) {
  //   return true;
  // }
  if(user.role === "Admin") {
    return true;
  }
  if(orgAdmin){
    return true
  }
}

export const canCommentOnTool = () => {
  /**
   * 
   * Comments are yet to be implemented.
   * will add required business logic once complete
   **/
}

export const canEditChart = (user, chart) => {

  let {permission, privacy}=chart
  if(chart && chart.isArchive && chart.isArchive.value) {
    return false;
  }
  if(chart.createdBy._id === user._id) {
      return true;
  }

  if( (chart.invitedUsers && chart.invitedUsers.length>0)) {
    let length = chart.invitedUsers.length
    for (var x =0; x<length; x++){
      let invitedU = chart.invitedUsers[x]
      if(invitedU.value === user._id.toString() && invitedU.permissions ===1){
        return true
      }
    }
  }

  if(privacy==='ENTERPRISE'){
    if(permission === "EDIT") {
      return true;
    }
  }

  // if(privacy === "OFFICE") {
  //     if(permission === "EDIT") {
  //         if(chart.officeId._id === user.officeId._id) {
  //             return true;
  //         }
  //     }
  // } else if(privacy === "OFFICE_AND_CHILDREN") {
  //     if(permission === "EDIT") {
  //         return true;
  //     }
  // }
  return false;
}

export const canArchiveChart = (user,chart) => {
  if(chart.createdBy._id === user._id) {
      return true;
  }
  return false;
}

export const canDeleteComment = (user,chartOwner,comment) => {
  if(user._id === comment.userId._id) {
    return true;
  }
  if(chartOwner._id === user._id) {
    return true;
  }
  return false;
}

export const canSetGoalsForChart = (chartOwner,profile,kpiData) => {
  if(kpiData.length > 0) {
    if(chartOwner._id === profile._id || profile.role === "Admin" ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}